/**
 * return the initials of a string if possible.
 * @param fullName string to get initials from
 */

interface GetInitialsProps {
  firstName?: string;
  lastName?: string;
  fullName?: string;
  email?: string;
}

export const getInitials = ({
  firstName,
  lastName,
  fullName,
  email
}: GetInitialsProps) => {
  if (!lastName && firstName) {
    return `${firstName?.trim()?.[0]}`.toUpperCase();
  }
  if (lastName && !firstName) {
    return `${lastName?.trim()?.[0]}`.toUpperCase();
  }
  if (!lastName && !firstName && email) {
    return `${email[0]}${email[1]}`.toUpperCase();
  }
  if (lastName && firstName) {
    return `${firstName?.trim()?.[0] || ''}${
      lastName?.trim()?.[0] || ''
    }`.toUpperCase();
  }
  if (fullName) {
    const splitName = fullName.split(' ');

    return `${splitName[0].charAt(0)}${splitName[1].charAt(0)}`;
  }

  return '';
};
